@let currentCoords = coords();
@if (currentCoords) {
  <p>
    {{ 'general.latitude' | translate }}:
    <strong>{{ currentCoords.latitude }}</strong>
    ; {{ 'general.longitude' | translate }}:
    <strong>{{ currentCoords.longitude }}</strong>
  </p>
} @else {
  <p>
    @if (geolocationErrors()) {
      <ion-text color="danger">{{ geolocationErrors() | translate }}</ion-text>
    } @else {
      {{ 'freight.general.get_geolocation' | translate }}
    }
  </p>
}
